/**
 * Serialise structured data for a <script type="application/ld+json"> block.
 *
 * JSON.stringify does not escape "<", so a string containing "</script>"
 * would end the script element and let the rest of the string run as markup.
 * Our schema data is editorial, but pharmacy and medication names can come
 * from the database, so every JSON-LD block goes through this instead.
 */
export function jsonLd(data: unknown): string {
  return JSON.stringify(data)
    .replace(/</g, '\\u003c')
    .replace(/>/g, '\\u003e')
    .replace(/&/g, '\\u0026')
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029');
}
